/* eslint-disable no-await-in-loop */
/* eslint-disable react/jsx-boolean-value */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable arrow-body-style */
/* eslint-disable react/no-array-index-key */
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Button,
  Chip,
  Divider,
  Grid,
  Paper,
  Stack,
  Typography,
  keyframes,
  styled
} from '@mui/material';
import ImgsViewer from 'react-images-viewer';
import PrintIcon from '@mui/icons-material/Print';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import SpeedSharpIcon from '@mui/icons-material/SpeedSharp';
import HourglassTopSharpIcon from '@mui/icons-material/HourglassTopSharp';
import HourglassBottomSharpIcon from '@mui/icons-material/HourglassBottomSharp';
import AccessTimeSharpIcon from '@mui/icons-material/AccessTimeSharp';
import React, { useContext, useEffect, useMemo, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { Container } from 'reactstrap';
import moment from 'moment';
import UIContext from '../../context/UIContext';
import axios from '../../utils/axios';

import {
  showProgressToast,
  completeProgressToast,
  dismissProgressToast,
  updateProgressToast,
} from '../../components/Snackbar/toastHelpers';

const FabricViewInspection = () => {
  const { FabricInspectionId } = useParams();
  // snackbar context
  const { openSnackBar, showLoading, hideLoading } = useContext(UIContext);
  const [headerData, setHeaderData] = useState({});
  const [auditData, setAuditData] = useState([]);
  const [defectData, setDefectData] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    getFabricInspectionDetail();
  }, []);

  const getFabricInspectionDetail = async () => {
    try {
      showLoading();
      const response = await axios.post('FabricInspection/ManageFabricInspection/GetFabricInspection', {
        FabricInspectionId
      });
      setHeaderData(response.data.InspectionHeader || {});
      setAuditData(response.data.AuditSummary || []);
      const Updateddefectdata = defectpointsAndPointsPer100Yd(response.data.DefectSummary || [])
      setDefectData(Updateddefectdata || []);
    } catch (e) {
      openSnackBar(e.response?.data?.message || 'Something Went Wrong try Again!', 'error');
    }
    hideLoading();
  };

  const defectpointsAndPointsPer100Yd = (DefectSummary) => {
    const updatedDefectData = DefectSummary.map(
      ({ DefectHeader, DefectDetail }) => {
        const Defectpoints = calculateDefectPoints(DefectDetail);
        const PointsPer100Yard = calculatePointsPer100Yards(DefectHeader, Defectpoints);
        return {
          DefectHeader: {
            ...DefectHeader,
            Defectpoints,
            PointsPer100Yard
          },
          DefectDetail,
        }
      })
    return updatedDefectData
  }

  const handlePrintClick = (inspection) => {
    const toastId = Date.now();
    showProgressToast(toastId, 'Downloading Fabric Inspection Report...', 0);
    getFabricInspectionPDF(inspection, toastId);
  };

  const getFabricInspectionPDF = async (inspection, toastId) => {
    let progress = 0;
    let progressInterval;
    let downloadCompleted = false;
    let lastUpdateTime = Date.now();
    const { InspectionCode, FabricInspectionId } = inspection;

    try {
      progressInterval = setInterval(() => {
        if (downloadCompleted) return;
        const elapsed = (Date.now() - lastUpdateTime) / 1000;
        const timeBasedProgress = Math.min(90, elapsed * 0.75);
        const randomFactor = 1 + (Math.random() * 0.2 - 0.1);
        progress = Math.min(90, timeBasedProgress * randomFactor);
        updateProgressToast(toastId, Math.floor(progress), `Processing Fabric Inspection Report ${InspectionCode}`);
      }, 300);

      // Replace with your actual PDF endpoint for fabric inspection
      const response = await axios.post(
        'fabricInspection/FabricInspectionHeader/FabricInspectionReportPdf',
        {
          FabricInspectionId,
          recipientEmail: sessionStorage.getItem('UserEmail')
        },
        {
          responseType: 'blob',
          onDownloadProgress: (progressEvent) => {
            if (progressEvent.total) {
              const realProgress = Math.floor((progressEvent.loaded * 100) / progressEvent.total);
              progress = Math.max(progress, Math.min(realProgress, 99));
              lastUpdateTime = Date.now();
            }
          },
        }
      );

      downloadCompleted = true;
      clearInterval(progressInterval);

      while (progress < 100) {
        progress = Math.min(progress + 2, 100);
        updateProgressToast(
          toastId,
          Math.floor(progress),
          `Finalizing Fabric Inspection Report ${InspectionCode}... (${Math.floor(progress)}%)`
        );
        await new Promise((resolve) => setTimeout(resolve, 50));
      }

      completeProgressToast(toastId, `Fabric Inspection Report ${InspectionCode} Downloaded & Copy has been Sent in Email!`);

      const fileName = `Fabric-Inspection-${inspection.Buyer}-${inspection.Style}-${inspection.InspectionCode}-${moment(inspection.StartDateTime).format('DD/MM/YYYY')}.pdf`
        .replace(/\s+/g, '')
        .replace(/\//g, '_');

      const blob = new Blob([response.data], { type: 'application/pdf' });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', fileName);
      document.body.appendChild(link);
      link.click();

      setTimeout(() => {
        link.remove();
        window.URL.revokeObjectURL(url);
      }, 200);
    } catch (e) {
      if (progressInterval) clearInterval(progressInterval);
      dismissProgressToast(toastId);
      const errorMsg = e.response?.data?.message || `Failed to download Fabric Inspection Report ${InspectionCode}`;
      openSnackBar(errorMsg, 'error');
    }
  };

  const [viewerOpen, setViewerOpen] = useState(false);
  const [currentImage, setCurrentImage] = useState(0);
  const [selectedImages, setSelectedImages] = useState([]);

  const handleOpenImages = (images, type) => {
    const imageURL = type === 'defect' ? axios.defaults.FabricInspectionDefectImageURL
      : axios.defaults.FabricInspectionAuditImageURL;

    const imageArray = typeof images === 'string' ? images.split(',').map((img) => img.trim()) : images;

    if (Array.isArray(imageArray) && imageArray.length > 0) {
      setSelectedImages(imageArray.map((img) => ({ src: `${imageURL}/${img}` })));
      setCurrentImage(0);
      setViewerOpen(true);
    }
  };

  const handleCloseViewer = () => {
    setViewerOpen(false);
  };

  const handleThumbnailClick = (index) => {
    setCurrentImage(index);
  };
  const calculateDefectPoints = (defectDetails = []) => {
    const filteredDefects = defectDetails.filter(defect => defect.Major !== 'Y');
    const sumOfDefectPoints = filteredDefects.reduce((sum, defect) =>
      sum + (parseFloat(defect.DefectPoint, 10) || 0), 0)
    return sumOfDefectPoints;

  }
  const calculatePointsPer100Yards = (defectHeader, totalPoints) => {
    const length = parseFloat(defectHeader?.ActualLength) || 0;
    const width = parseFloat(defectHeader?.ActualWidth) || 0;
    return (
      (totalPoints * 36 * 100) /
      (length * width)
    ).toFixed(2);
  };

  // Calculate total defect points
  const totalDefectPoints = useMemo(() => {
    return defectData.reduce((total, defectGroup) => {
      return total + defectGroup.DefectDetail.reduce((groupTotal, defect) => {
        return groupTotal + (parseInt(defect.DefectPoint, 10) || 0);
      }, 0);
    }, 0);
  }, [defectData]);

  // Calculate total major defects
  const totalMajorDefects = useMemo(() => {
    return defectData.reduce((total, defectGroup) => {
      return total + defectGroup.DefectDetail.filter(defect => defect.Major === 'Y').length;
    }, 0);
  }, [defectData]);

  const groupedAudits = useMemo(() => {
    const grouped = auditData.reduce((acc, item) => {
      const auditTypeId = String(item.AuditTypeId); // Ensure consistent key type

      if (!acc[auditTypeId]) {
        acc[auditTypeId] = {
          auditType: item.AuditType,
          overall: null,
          questions: [],
        };
      }

      if (item.Type?.toLowerCase() === 'overall') {
        acc[auditTypeId].overall = item;
      } else if (item.Type?.toLowerCase() === 'question') {
        acc[auditTypeId].questions.push(item);
      }

      return acc;
    }, {});

    // Convert object to array and sort with 'remarks' first
    const sorted = Object.entries(grouped)
      .map(([auditTypeId, data]) => ({ auditTypeId, ...data }))
      .sort((a, b) => {
        const aType = a.auditType?.trim().toLowerCase();
        const bType = b.auditType?.trim().toLowerCase();
        if (aType === 'remarks') return -1;
        if (bType === 'remarks') return 1;
        return 0;
      });

    return sorted;
  }, [auditData]);

  const pulse = keyframes`
  0% { transform: scale(1); }
  50% { transform: scale(1.05); }
  100% { transform: scale(1); }
`;

  // Styled component with animation
  const AnimatedTypography = styled(Typography)({
    animation: `${pulse} 2s ease-in-out infinite`,
    display: 'inline-block',
    padding: '4px 12px',
    borderRadius: '4px',
    backgroundColor: 'rgba(1, 146, 103, 0.1)'
  });

  return (
    <>
      <Container maxWidth={'xl'} elevation={3}>
        <Grid
          justifyContent={'space-between'}
          alignItems={'center'}
          spacing={2}
          sx={{ position: 'fixed', width: '100%', zIndex: viewerOpen ? 10 : 9700 }}
        >
          <Typography
            variant="h5"
            p={1}
            mx={2}
            boxShadow={1}
            borderColor="#11235A"
            textAlign={'center'}
            borderRadius={2}
            color="white"
            sx={{
              background: '#2b5258',
              boxShadow: 'rgba(60, 64, 67, 0.3) 0px 1px 2px 0px, rgba(60, 64, 67, 0.15) 0px 2px 6px 2px',
            }}
          >
            <Typography variant="subtitle1" color="white" textAlign={'center'}>
              FABRIC INSPECTION PREVIEW{' '}
              <Chip
                label={
                  headerData.InspectionStatus?.trim() === 'P'
                    ? 'Pass'
                    : headerData.InspectionStatus?.trim() === 'F'
                      ? 'Fail'
                      : 'Hold'
                }
                size="small"
                color={
                  headerData.InspectionStatus?.trim() === 'P'
                    ? 'success'
                    : headerData.InspectionStatus?.trim() === 'F'
                      ? 'error'
                      : 'warning'
                }

              />
            </Typography>
          </Typography>
        </Grid>
        <Stack m={3} pt={6}>
          <Box sx={{ display: 'flex', flexDirection: 'column', p: 2 }}>
            <Stack
              direction={{ xs: 'row', md: 'row' }}
              justifyContent={'space-between'}
              alignItems={'center'}
              spacing={2}
            >
              <Stack
                direction={{ xs: 'column', md: 'row' }}
                justifyContent={'space-between'}
                alignItems={'center'}
                spacing={2}
              >
                <Box>
                  {FabricInspectionId && (
                    <Typography variant="h6" color="GrayText">
                      INSPECTION NO : {headerData.InspectionCode}
                    </Typography>
                  )}
                </Box>
              </Stack>
              <Stack
                direction={{ xs: 'column', md: 'row' }}
                justifyContent={'space-between'}
                alignItems={'center'}
                spacing={2}
              >
                <Box>
                  <Typography variant="h6" color="GrayText">
                    Date : <span>{moment(headerData.StartDateTime).format('DD/MM/YYYY')}</span>
                  </Typography>
                </Box>
              </Stack>
            </Stack>

            <Divider sx={{ mb: 2 }}>
              <Chip label="Inspection Details" size="small" />
            </Divider>

            <Grid container spacing={2}>
              <Grid item xs={12} md={4}>
                <Paper elevation={2} sx={{ bgcolor: 'inherit', p: 1 }}>
                  <Stack justifyContent={'flex-start'} direction={'column'}>
                    <Typography variant="subtitle2" color="GrayText" pr={1}>
                      Buyer
                    </Typography>
                    <Typography variant="subtitle1" color="#009688">
                      {headerData.Buyer}
                    </Typography>
                  </Stack>
                </Paper>
              </Grid>
              <Grid item xs={12} md={4}>
                <Paper elevation={2} sx={{ bgcolor: 'inherit', p: 1 }}>
                  <Stack justifyContent={'flex-start'} direction={'column'}>
                    <Typography variant="subtitle2" color="GrayText" pr={1}>
                      Factory
                    </Typography>
                    <Typography variant="subtitle1" color="#009688">
                      {headerData.Factory}
                    </Typography>
                  </Stack>
                </Paper>
              </Grid>
              <Grid item xs={12} md={4}>
                <Paper elevation={2} sx={{ bgcolor: 'inherit', p: 1 }}>
                  <Stack justifyContent={'flex-start'} direction={'column'}>
                    <Typography variant="subtitle2" color="GrayText" pr={1}>
                      Style
                    </Typography>
                    <Typography variant="subtitle1" color="#009688">
                      {headerData.Style}
                    </Typography>
                  </Stack>
                </Paper>
              </Grid>
              <Grid item xs={6} md={4}>
                <Paper elevation={2} sx={{ bgcolor: 'inherit', p: 1 }}>
                  <Stack justifyContent={'flex-start'} direction={'column'}>
                    <Typography variant="subtitle2" color="GrayText" pr={1}>
                      Fabric Description
                    </Typography>
                    <Typography variant="subtitle1" color="#009688">
                      {headerData.FabricDescription}
                    </Typography>
                  </Stack>
                </Paper>
              </Grid>
              <Grid item xs={6} md={4}>
                <Paper elevation={2} sx={{ bgcolor: 'inherit', p: 1 }}>
                  <Stack justifyContent={'flex-start'} direction={'column'}>
                    <Typography variant="subtitle2" color="GrayText" pr={1}>
                      Production Coordinator
                    </Typography>
                    <Typography variant="subtitle1" color="#009688">
                      {headerData.CoordinatorNames || 'N/A'}
                    </Typography>
                  </Stack>
                </Paper>
              </Grid>
              <Grid item xs={6} md={4}>
                <Paper elevation={2} sx={{ bgcolor: 'inherit', p: 1 }}>
                  <Stack justifyContent={'flex-start'} direction={'column'}>
                    <Typography variant="subtitle2" color="GrayText" pr={1}>
                      Assisting QA
                    </Typography>
                    <Typography variant="subtitle1" color="#009688">
                      {headerData.AssistingQANames || 'N/A'}
                    </Typography>
                  </Stack>
                </Paper>
              </Grid>

              <Grid item xs={6} md={3}>
                <Paper elevation={2} sx={{ bgcolor: 'inherit', p: 1 }}>
                  <Stack justifyContent={'flex-start'} direction={'column'}>
                    <Typography variant="subtitle2" color="GrayText" pr={1}>
                      Inspector
                    </Typography>
                    <Typography variant="subtitle1" color="#009688">
                      {headerData.Inspector}
                    </Typography>
                  </Stack>
                </Paper>
              </Grid>
              <Grid item xs={12} md={3}>
                <Paper elevation={2} sx={{ bgcolor: 'inherit', p: 1 }}>
                  <Stack justifyContent={'flex-start'} direction={'column'}>
                    <Typography variant="subtitle2" color="GrayText" pr={1}>
                      Fabric Supplier:
                    </Typography>
                    <Typography variant="subtitle1" color="#009688">
                      {headerData.FabricSupplier || 'N/A'}
                    </Typography>
                  </Stack>
                </Paper>
              </Grid>
              <Grid item xs={12} md={3}>
                <Paper elevation={2} sx={{ bgcolor: 'inherit', p: 1 }}>
                  <Stack justifyContent={'flex-start'} direction={'column'}>
                    <Typography variant="subtitle2" color="GrayText" pr={1}>
                      Country of Origin:
                    </Typography>
                    <Typography variant="subtitle1" color="#009688">
                      {headerData.CountryOfOrigin || 'N/A'}
                    </Typography>
                  </Stack>
                </Paper>
              </Grid>

              <Grid item xs={6} md={3}>
                <Paper elevation={2} sx={{ bgcolor: 'inherit', p: 1 }}>
                  <Stack justifyContent={'flex-start'} direction={'column'}>
                    <Typography variant="subtitle2" color="GrayText" pr={1}>
                      PO Number
                    </Typography>
                    <Typography variant="subtitle1" color="#009688">
                      {headerData.PoNo || 'N/A'}
                    </Typography>
                  </Stack>
                </Paper>
              </Grid>
              {/* <Grid item xs={6} md={4}>
                <Paper elevation={2} sx={{ bgcolor: 'inherit', p: 1 }}>
                  <Stack justifyContent={'flex-start'} direction={'column'}>
                    <Typography variant="subtitle2" color="GrayText" pr={1}>
                      IPO Number
                    </Typography>
                    <Typography variant="subtitle1" color="#009688">
                      {headerData.IpoNo}
                    </Typography>
                  </Stack>
                </Paper>
              </Grid>
              <Grid item xs={6} md={4}>
                <Paper elevation={2} sx={{ bgcolor: 'inherit', p: 1 }}>
                  <Stack justifyContent={'flex-start'} direction={'column'}>
                    <Typography variant="subtitle2" color="GrayText" pr={1}>
                      WO Number
                    </Typography>
                    <Typography variant="subtitle1" color="#009688">
                      {headerData.WoNo}
                    </Typography>
                  </Stack>
                </Paper>
              </Grid> */}
            </Grid>

            {/* Rolls Information */}
            <Grid item xs={12}>
              <Divider sx={{ mt: 3, mb: 2 }}>
                <Chip label="Rolls Information" size="small" />
              </Divider>
            </Grid>
            <Grid container spacing={2}>
              <Grid item xs={6} md={3}>
                <Paper elevation={2} sx={{ bgcolor: 'inherit', p: 1, textAlign: 'center' }}>
                  <Typography variant="subtitle2" color="GrayText">
                    Rolls Received
                  </Typography>
                  <Typography variant="h6" color="primary">
                    {headerData.RollsReceived}
                  </Typography>
                </Paper>
              </Grid>
              <Grid item xs={6} md={3}>
                <Paper elevation={2} sx={{ bgcolor: 'inherit', p: 1, textAlign: 'center' }}>
                  <Typography variant="subtitle2" color="GrayText">
                    Rolls Received Weight
                  </Typography>
                  <Typography variant="h6" color="primary">
                    {headerData.RollsReceivedWeight} kg
                  </Typography>
                </Paper>
              </Grid>
              <Grid item xs={6} md={3}>
                <Paper elevation={2} sx={{ bgcolor: 'inherit', p: 1, textAlign: 'center' }}>
                  <Typography variant="subtitle2" color="GrayText">
                    Rolls To Inspect
                  </Typography>
                  <Typography variant="h6" color="primary">
                    {headerData.RollsToInspect}
                  </Typography>
                </Paper>
              </Grid>
              <Grid item xs={6} md={3}>
                <Paper elevation={2} sx={{ bgcolor: 'inherit', p: 1, textAlign: 'center' }}>
                  <Typography variant="subtitle2" color="GrayText">
                    Rolls To Inspect Weight
                  </Typography>
                  <Typography variant="h6" color="primary">
                    {headerData.RollsToInspectWeight} kg
                  </Typography>
                </Paper>
              </Grid>
            </Grid>

            {auditData && (
              <>
                <Grid item xs={12}>
                  <Divider sx={{ mt: 1 }}>
                    <Chip label="Audit Summary" size="small" />
                  </Divider>
                </Grid>
                <Grid item xs={12}>
                  <Paper elevation={2} sx={{ bgcolor: 'inherit' }}>
                    {Object.keys(groupedAudits).map((auditTypeId) => {
                      const auditGroup = groupedAudits[auditTypeId];
                      return (
                        <Accordion key={auditTypeId} sx={{ bgcolor: 'inherit' }}>
                          <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                            {auditGroup.overall && (
                              <>
                                <Typography variant="h6" color={'#229799'}>
                                  {auditGroup.auditType}
                                  <Chip
                                    label={
                                      auditGroup.overall.AuditStatus.trim() === 'P'
                                        ? 'Pass'
                                        : auditGroup.overall.AuditStatus.trim() === 'F'
                                          ? 'Fail'
                                          : auditGroup.overall.AuditStatus.trim() === 'H'
                                            ? 'Hold'
                                            : 'N / A'
                                    }
                                    size="small"
                                    color={
                                      auditGroup.overall.AuditStatus.trim() === 'P'
                                        ? 'success'
                                        : auditGroup.overall.AuditStatus.trim() === 'F'
                                          ? 'error'
                                          : auditGroup.overall.AuditStatus.trim() === 'H'
                                            ? 'warning'
                                            : 'default'
                                    }
                                    sx={{ ml: 1 }}
                                  />{' '}
                                  <br />
                                  <Typography variant="body2">{auditGroup.overall.AuditComment}</Typography>
                                </Typography>
                              </>
                            )}
                          </AccordionSummary>
                          <AccordionDetails>
                            <>
                              {' '}
                              <Divider sx={{ mb: 2 }}>
                                <Chip label="Overview" size="small" />
                              </Divider>
                              {/* Question-based Audits */}
                              {auditGroup.questions.map((question, index) => (
                                <Paper key={index} elevation={3} sx={{ p: 2, mb: 2, bgcolor: 'inherit' }}>
                                  <Grid container spacing={2}>
                                    {/* Left: Question & Comment */}
                                    <Grid item xs={6}>
                                      <Typography variant="subtitle2" color="GrayText">
                                        {question.Question || 'No Classification'}
                                      </Typography>
                                      <Typography variant="body2">{question.AuditComment}</Typography>
                                    </Grid>

                                    {/* Right: Result & View Images (Stacked) */}
                                    <Grid item xs={6} textAlign="right">
                                      <Stack spacing={1} alignItems="flex-end">
                                        {/* Audit Status */}
                                        <Chip
                                          label={
                                            question.AuditStatus.trim() === 'P'
                                              ? 'Pass'
                                              : question.AuditStatus.trim() === 'F'
                                                ? 'Fail'
                                                : question.AuditStatus.trim() === 'H'
                                                  ? 'Hold'
                                                  : 'N / A'
                                          }
                                          size="small"
                                          ss
                                          color={
                                            question.AuditStatus.trim() === 'P'
                                              ? 'success'
                                              : question.AuditStatus.trim() === 'F'
                                                ? 'error'
                                                : question.AuditStatus.trim() === 'H'
                                                  ? 'warning'
                                                  : 'info'
                                          }
                                        />

                                        {/* View Images Button */}
                                        {question.Images && (
                                          <Button
                                            size="small"
                                            onClick={() => handleOpenImages(question.Images, 'audit')}
                                          >
                                            View Images
                                          </Button>
                                        )}
                                      </Stack>
                                    </Grid>
                                  </Grid>
                                </Paper>
                              ))}
                            </>
                          </AccordionDetails>
                        </Accordion>
                      );
                    })}
                  </Paper>
                </Grid>
              </>
            )}


            {/* Defect Summary */}
            {defectData.length > 0 && (
              <>
                <Grid item xs={12}>
                  <Divider sx={{ mt: 3, mb: 2 }}>
                    <Chip label="Defect Summary" size="small" />
                  </Divider>
                </Grid>
                {defectData.map((defectGroup, groupIndex) => (
                  <Accordion key={groupIndex} sx={{ bgcolor: 'inherit', mb: 2 }}>
                    {/* <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                      <Typography variant="h6" color="#019267">
                        Roll No: {defectGroup.DefectHeader.RollNo} | Color: {defectGroup.DefectHeader.Color}
                        
                       {defectGroup.DefectHeader.PointsPer100Yard >= 40 && 
                       <Chip label="Rejected" size="small"  color='error'/> 
                        } 
                      </Typography>
                      
                    </AccordionSummary> */}
                    <AccordionSummary
                      expandIcon={<ExpandMoreIcon />}
                      sx={{
                        backgroundColor: defectGroup.DefectHeader.PointsPer100Yard >= 40
                          ? 'rgba(211, 47, 47, 0.08)'
                          : 'rgba(1, 146, 103, 0.08)',
                        borderLeft: defectGroup.DefectHeader.PointsPer100Yard >= 40
                          ? '4px solid #d32f2f'
                          : '4px solid #019267',
                        minHeight: '72px !important',
                        '& .MuiAccordionSummary-content': {
                          margin: '12px 0 !important',
                          alignItems: 'center',
                          flexWrap: 'wrap'
                        }
                      }}
                    >
                      <Box sx={{ display: 'flex', flexDirection: 'column', width: '100%' }}>
                        {/* Top line with Roll No, Color and Points */}
                        <Box sx={{
                          display: 'flex',
                          alignItems: 'center',
                          flexWrap: 'wrap',
                          gap: 1,
                          mb: 1
                        }}>
                          <Typography variant="h6" sx={{ color: '#019267', fontWeight: 600 }}>
                            Roll No: {defectGroup.DefectHeader.RollNo} | Color: {defectGroup.DefectHeader.Color}
                          </Typography>



                          {defectGroup.DefectHeader.PointsPer100Yard >= 40 ? (
                            <Chip
                              label="Rejected"
                              size="small"
                              color="error"
                              sx={{
                                fontWeight: 600,
                                fontSize: '0.75rem'
                              }}
                            />
                          )
                            :
                            (<Chip
                              label="Accepted"
                              size="small"
                              color="success"
                              sx={{
                                fontWeight: 600,
                                fontSize: '0.75rem'
                              }}
                            />)

                          }
                        </Box>

                        <Typography variant="body1" sx={{ color: '#019267', fontWeight: 200, fontSize: 15 }}>
                          Points Per 100 yard : {defectGroup.DefectHeader.PointsPer100Yard}
                        </Typography>
                      </Box>
                    </AccordionSummary>
                    <AccordionDetails>
                      {/* Roll Details */}
                      <Grid container spacing={2} sx={{ mb: 3 }}>
                        <Grid item xs={6} md={3}>
                          <Typography variant="body2">
                            <b>Marked Weight :</b> {defectGroup.DefectHeader.MarkedWeight} kg
                          </Typography>
                        </Grid>
                        <Grid item xs={6} md={3}>
                          <Typography variant="body2">
                            <b>Actual Weight :</b> {defectGroup.DefectHeader.ActualWeight} kg
                          </Typography>
                        </Grid>
                        <Grid item xs={6} md={3}>
                          <Typography variant="body2">
                            <b>Marked Length :</b> {defectGroup.DefectHeader.MarkedLength} yd
                          </Typography>
                        </Grid>
                        <Grid item xs={6} md={3}>
                          <Typography variant="body2">
                            <b>Actual Length :</b> {defectGroup.DefectHeader.ActualLength} yd
                          </Typography>
                        </Grid>
                        <Grid item xs={6} md={3}>
                          <Typography variant="body2">
                            <b>Required Width :</b> {defectGroup.DefectHeader.RequiredWidth} inch
                          </Typography>
                        </Grid>
                        <Grid item xs={6} md={3}>
                          <Typography variant="body2">
                            <b>Actual Width :</b> {defectGroup.DefectHeader.ActualWidth} inch
                          </Typography>
                        </Grid>
                        <Grid item xs={6} md={3}>
                          <Typography variant="body2">
                            <b>Actual GSM :</b> {defectGroup.DefectHeader.ActualGSM}
                          </Typography>
                        </Grid>

                        <Grid item xs={12}>
                          <Typography variant="body2">
                            <b>Remarks :</b> {defectGroup.DefectHeader.Remarks}
                          </Typography>
                        </Grid>
                      </Grid>

                      <Divider sx={{ mb: 2 }}>
                        <Chip label="Defects" size="small" />
                      </Divider>

                      {/* Defect Details */}
                      {defectGroup.DefectDetail.map((defect, index) => {
                        const images = [
                          defect.DefectImage1,
                          defect.DefectImage2,
                          defect.DefectImage3,
                          defect.DefectImage4
                        ].filter(Boolean);

                        return (
                          <Paper key={index} elevation={2} sx={{ p: 2, mb: 2, bgcolor: 'inherit' }}>
                            <Grid container spacing={2} alignItems="center">
                              <Grid item xs={8}>
                                <Typography variant="subtitle1" color="#27496D">
                                  {defect.DefectDescription}
                                </Typography>
                                <Typography variant="body2">
                                  Points: {defect.DefectPoint} |
                                  Type: <Chip
                                    label={defect.Major === 'Y' ? 'Major' : 'Minor'}
                                    size="small"
                                    color={defect.Major === 'Y' ? 'error' : 'warning'}
                                    sx={{ ml: 1 }}
                                  />
                                </Typography>
                              </Grid>
                              <Grid item xs={4} sx={{ textAlign: 'right' }}>
                                {images.length > 0 && (
                                  <Button
                                    size="small"
                                    onClick={() => handleOpenImages(images, 'defect')}
                                  >
                                    View Images
                                  </Button>
                                )}
                              </Grid>
                            </Grid>
                          </Paper>
                        );
                      })}
                    </AccordionDetails>
                  </Accordion>
                ))}
              </>
            )}

            {/* Summary Statistics */}
            <Grid item xs={12}>
              <Divider sx={{ my: 2 }}>
                <Chip label="Summary Statistics" size="small" />
              </Divider>
            </Grid>
            <Grid container spacing={2}>
              <Grid item xs={6} md={4}>
                <Paper elevation={3} sx={{ p: 2, textAlign: 'center', bgcolor: '#ffe16a70' }}>
                  <Typography variant="body1" fontWeight="bold">
                    Total Defect Points
                  </Typography>
                  <Typography variant="h4" color="warning.dark">
                    {totalDefectPoints}
                  </Typography>
                </Paper>
              </Grid>
              <Grid item xs={6} md={4}>
                <Paper elevation={3} sx={{ p: 2, textAlign: 'center', bgcolor: '#ffa48d5e' }}>
                  <Typography variant="body1" fontWeight="bold">
                    Major Defects
                  </Typography>
                  <Typography variant="h4" color="error.dark">
                    {totalMajorDefects}
                  </Typography>
                </Paper>
              </Grid>
              <Grid item xs={12} md={4}>
                <Paper elevation={3} sx={{ p: 2, textAlign: 'center', bgcolor: '#74caff6b' }}>
                  <Typography variant="body1" fontWeight="bold">
                    Total Rolls Inspected
                  </Typography>
                  <Typography variant="h4" color="info.dark">
                    {defectData.length}
                  </Typography>
                </Paper>
              </Grid>
            </Grid>

            {/* Additional Information */}
            <Grid item xs={12}>
              <Divider sx={{ my: 2 }}>
                <Chip label="Additional Information" size="small" />
              </Divider>
            </Grid>
            <Grid container spacing={2}>

              <Grid item xs={12} md={3}>
                <Paper elevation={2} sx={{ bgcolor: 'inherit', p: 1 }}>
                  <Stack justifyContent={'flex-start'} direction={'column'}>
                    <Stack direction="row" alignItems="center" spacing={1}>
                      <SpeedSharpIcon fontSize="small" />
                      <Typography variant="subtitle2" color="GrayText">
                        Machine Speed
                      </Typography>
                    </Stack>
                    <Typography variant="subtitle1" color="#009688" sx={{ textIndent: '30px' }}>
                      {headerData.MachineSpeed || 'N/A'}
                    </Typography>
                  </Stack>
                </Paper>
              </Grid>

              <Grid item xs={12} md={3}>
                <Paper elevation={2} sx={{ bgcolor: 'inherit', p: 1 }}>
                  <Stack justifyContent={'flex-start'} direction={'column'}>
                    <Stack direction="row" alignItems="center" spacing={1}>
                      <HourglassTopSharpIcon fontSize="small" />
                      <Typography variant="subtitle2" color="GrayText" pr={1}>
                        Machine Start Time
                      </Typography>
                    </Stack>
                    <Typography variant="subtitle1" color="#009688" sx={{ textIndent: '30px' }}>
                      {headerData.MachineStartTime ? moment(headerData.MachineStartTime).format('HH:mm') : 'N/A'}
                    </Typography>
                  </Stack>
                </Paper>
              </Grid>

              <Grid item xs={12} md={3}>
                <Paper elevation={2} sx={{ bgcolor: 'inherit', p: 1 }}>
                  <Stack justifyContent={'flex-start'} direction={'column'}>
                    <Stack direction="row" alignItems="center" spacing={1}>
                      <HourglassBottomSharpIcon fontSize="small" />
                      <Typography variant="subtitle2" color="GrayText" pr={1}>
                        Machine End Time
                      </Typography>
                    </Stack>
                    <Typography variant="subtitle1" color="#009688" sx={{ textIndent: '30px' }}>
                      {headerData.MachineEndTime ? moment(headerData.MachineEndTime).format('HH:mm') : 'N/A'}
                    </Typography>
                  </Stack>
                </Paper>
              </Grid>


              <Grid item xs={12} md={3}>
                <Paper elevation={2} sx={{ bgcolor: 'inherit', p: 1 }}>
                  <Stack justifyContent={'flex-start'} direction={'column'}>
                    <Stack direction="row" alignItems="center" spacing={1}>
                      <AccessTimeSharpIcon fontSize="small" />
                      <Typography variant="subtitle2" color="GrayText" pr={1}>
                        Duration
                      </Typography>
                    </Stack>
                    <Typography variant="subtitle1" color="#009688" sx={{ textIndent: '30px' }}>
                      {` ${headerData.MachineStartTime && headerData.MachineEndTime
                        ? `${moment.duration(moment(headerData.MachineEndTime).diff(moment(headerData.MachineStartTime))).hours()}h ${moment.duration(moment(headerData.MachineEndTime).diff(moment(headerData.MachineStartTime))).minutes()}m`
                        : 'N/A'
                        }`}
                    </Typography>
                  </Stack>
                </Paper>
              </Grid>
            </Grid>


            {/* <Paper elevation={3} sx={{ p: 3, bgcolor: 'inherit' }}>
              <Grid container spacing={2}>
                <Grid item xs={12} md={6}>
                  <Typography variant="body1">
                    <b>Country of Origin:</b> {headerData.CountryOfOrigin || 'N/A'}
                  </Typography>
                  <Typography variant="body1">
                    <b>Fabric Supplier:</b> {headerData.FabricSupplier || 'N/A'}
                  </Typography>
                  <Typography variant="body1">
                    <b>Machine Speed:</b> {headerData.MachineSpeed || 'N/A'}
                  </Typography>
                </Grid>
                <Grid item xs={12} md={6}>
                  <Typography variant="body1">
                    <b>Machine Start Time:</b> {headerData.MachineStartTime ? moment(headerData.MachineStartTime).format('DD/MM/YYYY HH:mm') : 'N/A'}
                  </Typography>
                  <Typography variant="body1">
                    <b>Machine End Time:</b> {headerData.MachineEndTime ? moment(headerData.MachineEndTime).format('DD/MM/YYYY HH:mm') : 'N/A'}
                  </Typography>
                   <Typography variant="body1">
                   <b>Duration:</b> {` ${
                        headerData.MachineStartTime && headerData.MachineEndTime
                          ? `${moment.duration(moment(headerData.MachineEndTime).diff(moment(headerData.MachineStartTime))).hours()}h ${moment.duration(moment(headerData.MachineEndTime).diff(moment(headerData.MachineStartTime))).minutes()}m`
                          : 'N/A'
                      }`}
                  </Typography>
                  <Typography variant="body1">
                    <b>Remarks:</b> {headerData.Remarks || 'N/A'}
                  </Typography>
                </Grid>
              </Grid>
            </Paper> */}

            {/* Signatures */}
            <Paper elevation={3} sx={{ p: 3, mt: 2, bgcolor: 'inherit' }}>
              <Divider sx={{ mb: 2 }}>
                <Chip label="Declarations" size="small" />
              </Divider>
              <Grid container spacing={2} alignItems="start">
                <Grid item xs={6}>
                  <Typography variant="body1">
                    <b>Factory Representative:</b> {headerData.Representative || 'N/A'}
                  </Typography>
                  <Typography variant="body2" color="textSecondary">
                    {headerData.RepresentativeDesignation || 'N/A'}
                  </Typography>
                  {headerData.RepresentativeSign && (
                    <img
                      src={`${axios.defaults.FabricInspectionImageURL}/${headerData.RepresentativeSign}`}
                      alt="Factory Representative Signature"
                      style={{ width: 120, marginTop: 8, mixBlendMode: 'multiply' }}
                    />
                  )}
                  <Typography
                    variant="body2"
                    sx={{ mt: 1, fontStyle: 'italic', color: 'gray', textAlign: 'left' }}
                  >
                    {headerData.TermsAndConditions || 'This is a random inspection, and the factory is fully responsible for the entire quality of the product. Carefully close the remaining cartons that were selected for inspection. If there are any claims due to quality issues, the factory is liable for them. Please check with the vendor’s office to dispatch the goods.'}
                  </Typography>
                </Grid>
                {/* <Grid item xs={2}>
                  <Divider orientation="vertical" flexItem />
                </Grid> */}
                <Grid item xs={6} sx={{ textAlign: 'right' }}>
                  <Typography variant="body1" fontWeight="bold">
                    Inspector Signature
                  </Typography>
                  {headerData.InspectorSign && (
                    <img
                      src={`${axios.defaults.FabricInspectionImageURL}/${headerData.InspectorSign}`}
                      alt="Inspector Signature"
                      style={{
                        width: 120,
                        marginTop: 8,
                        display: 'block',
                        marginLeft: 'auto',
                        mixBlendMode: 'multiply',
                      }}
                    />
                  )}

                </Grid>
              </Grid>
            </Paper>

            <Stack direction="row" justifyContent={'center'} alignItems={'center'} spacing={2} mt={3}>
              <Button variant="contained" color="primary" onClick={() => navigate(-1)}>
                Back
              </Button>
              <Button
                variant="contained"
                color="warning"
                startIcon={<PrintIcon />}
                onClick={() => handlePrintClick(headerData)}
              >
                Print
              </Button>
            </Stack>
          </Box>
        </Stack>
        <ImgsViewer
          imgs={selectedImages}
          isOpen={viewerOpen}
          currImg={currentImage}
          onClickPrev={() => setCurrentImage((prev) => (prev > 0 ? prev - 1 : prev))}
          onClickNext={() => setCurrentImage((prev) => (prev < selectedImages.length - 1 ? prev + 1 : prev))}
          onClose={handleCloseViewer}
          showThumbnails={true}
          onClickThumbnail={handleThumbnailClick}
          enableZoom={true}
        />
      </Container>
    </>
  );
};

export default FabricViewInspection;